import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn, Router } from '@angular/router';
import { DossierService } from '@shared/services/cabinet/dossier.service';

export const dossierDeTravailGuard: CanActivateFn = (route) => {
  const snackBar = inject(MatSnackBar);
  const dossierService = inject(DossierService);
  const router = inject(Router);

  // dossierResolver.dossier n'est pas accessible sur un refresh.
  // Si le dossier n'est pas accessible (id undefined),
  // 1. on entre dans le composant, le resolver sera alors terminé
  // 2. une 2nd vérification sera faite par le composant
  if (
    !dossierService.currentDossier.id ||
    dossierService.currentDossier.isSaisieTravailAutorise
  ) {
    return true;
  }
  snackBar.open("Vous n'êtes pas autorisé à accéder au dossier annuel", 'Ok');
  const dossierId = route.parent?.paramMap.get('id');
  if (dossierId) {
    return router.parseUrl(`/dossier/${dossierId}/accueil`);
  }

  // Fallback de sécurité vers la racine si l'ID est introuvable
  return router.parseUrl('/');
};
